import { ENDPOINTS } from './endpoints';
import { getJson } from './client';

export const getSettings = async () => getJson(ENDPOINTS.SETTINGS);
